import { render } from "./Hosting.vue?vue&type=template&id=1be67064&scoped=true"
import script from "./Hosting.vue?vue&type=script&lang=js"
export * from "./Hosting.vue?vue&type=script&lang=js"

import "./Hosting.vue?vue&type=style&index=0&id=1be67064&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be67064"]])

export default __exports__